import React from "react";
import "~/css/ConversationAccordion.css";
import ConversationAccordionItem from "./ConversationAccordionItem";

/** 入れ子専用アコーディオン: Accordion へ影響を与えず個別拡張 */
export interface ConversationAccordionProps {
  items: {
    title: string | React.JSX.Element;
    content: React.ReactNode;
    externalContent: React.ReactNode;
    dynamicHeight?: boolean;
    summaryClassName?: string; // カスタムクラス
    defaultOpen?: boolean; // 初期展開
  }[];
  groupClassName?: string; // ルートラッパー
}

/**
 * 入れ子専用アコーディオン
 */
const ConversationAccordion: React.FC<ConversationAccordionProps> = ({
  items,
  groupClassName = "",
}) => {
  return (
    <div className={groupClassName}>
      {items.map((item, idx) => (
        <React.Fragment key={idx}>
          <ConversationAccordionItem
            title={item.title}
            dynamicHeight={item.dynamicHeight}
            summaryClassName={item.summaryClassName}
            defaultOpen={item.defaultOpen}
          >
            {item.content}
          </ConversationAccordionItem>
          {item.externalContent}
        </React.Fragment>
      ))}
    </div>
  );
};

export default ConversationAccordion;
